export default __webpack_public_path__ + "static/media/studyGuidesIcon.f8bef21a.svg";